import axios from 'axios'
import { createPrefix } from 'utils/create-prefix'

export class EventService {
  constructor() {
    this.endpoints = {
      ...createPrefix('/tournament/matches', {
        index: '/',
        eventSearch: '/search',
      }),

      ...createPrefix('/tournament/match', {
        instance: (id) => `/${id}`,
      }),
    }
  }

  static create() {
    return new EventService()
  }

  async query(params) {
    const servicePath = this.endpoints.eventSearch()
    const { data } = await axios.get(servicePath, { params })
    return data
  }

  async get(id) {
    const servicePath = this.endpoints.instance(id)
    const { data } = await axios.get(servicePath)
    return data
  }
}
